export default __webpack_public_path__ + "static/media/wayne-gretzky.ed6bf3a1.png";